import {Record} from 'immutable';

const Condition = Record({
    id: null,
    conditionId: null,
    name: '',
    optionName: '',
});

export default Condition;